import 'jquery';
import { debounce } from "throttle-debounce";

export default {
  __NS__: 'off-canvas',
  items: '.dropdown-toggle',
  init() {
    const _ = this;
    const $body = $('body');
    const $offCanvas = $(`.${this.__NS__}`);

    // Move off-canvas to body.
    $offCanvas.prependTo($body);

    // Ensure wrapper / container element.
    if (!$offCanvas.parent(`.${this.__NS__}__container`).length) {
      $offCanvas.wrap(`<div class="${this.__NS__}__container"></div>`);
    }

    $(window).on(
      `resize.${this.__NS__}`,
      debounce(200, event => {
        return;
        const availableHeight = $offCanvas.height();
        const $nav = $('.nav', $offCanvas);
        const $navItems = $('.nav', $nav);
        window.console.log(availableHeight, event, this);
      })
    );

    // Container
    // const $container = $offCanvas.parent(`.${this.__NS__}__container`);
    // $(document).on(`click.${this.__NS__}`, event => {
    //   return (
    //     !$(event.target).closest($offCanvas).length &&
    //     $offCanvas.is(":visible") &&
    //     $(".navbar-toggler").trigger(`click.${this.__NS__}`)
    //   );
    // });

    // Add event handler on hamburger.
    $('.navbar-toggler').on(`click.${this.__NS__}`, event => {
      $body.toggleClass(`${this.__NS__}--shown`);

      if ($(event.currentTarget).hasClass('is-active')) {
        $(this.items, $offCanvas)
          .parent()
          .removeClass('is-active');
        $offCanvas.removeClass(`${this.__NS__}__sublevel--shown`);
      }
    });

    // Remove utility classes from navs.
    $('.nav', $offCanvas).each((i, nav) => {
      nav.className = nav.className.replace(/d-((sm|md|lg|xl)-)?((inline-)?(block|none|flex))/g, '');
    });

    // Add event handler on sub-level parents.
    $offCanvas.on(`click.${this.__NS__}`, this.items, event => {
      event.preventDefault();
      const $link = $(event.currentTarget);
      const $parent = $link.parent();
      $parent.toggleClass('is-active');
      $offCanvas.addClass(`${this.__NS__}__sublevel--shown`);
    });

    $('.dropdown-menu', $offCanvas).each((i, menu) => {
      // Menu
      const $menu = $(menu);

      // Header
      const $header = $(`<div class="${this.__NS__}__header"></div>`);

      // Add toggler as label / link.
      const $toggle = $menu.prev('.dropdown-toggle');
      $toggle
        .clone()
        .removeClass('dropdown-toggle active')
        .addClass(`${this.__NS__}__parent`)
        .prependTo($header);

      // Add back button.
      const btnHtml = `<a class="dropdown-item ${
        this.__NS__
      }__nav" role="button"><i class="fal fa-angle-left fa-lg fa-fw"></i></a>`;
      const $btn = $(btnHtml);
      $btn
        .on(`click.${this.__NS__}`, event => {
          event.preventDefault();
          $offCanvas.removeClass(`${this.__NS__}__sublevel--shown`);
          const $btn = $(event.target);
          $btn
            .closest('.dropdown-menu')
            .parent()
            .removeClass('is-active');
        })
        .prependTo($header);

      $header.prependTo($menu);
    });
  },
  finalize() {
    const $body = $('body');

    // Remove dropdown hover events.
    $body.off('mouseenter mouseleave', '.dropdown');
  },
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/hasOffCanvas.js